/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Expense_Rule_Vendor_Name_Too_LongInputs */

const vi_error_expense_rule_vendor_name_too_long = /** @type {(inputs: Error_Expense_Rule_Vendor_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên người nhận tối đa 255 ký tự.`)
};

/**

* @param {Error_Expense_Rule_Vendor_Name_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_expense_rule_vendor_name_too_long = /** @type {((inputs?: Error_Expense_Rule_Vendor_Name_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Expense_Rule_Vendor_Name_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_expense_rule_vendor_name_too_long(inputs)
});